export default class anchorScroll {
  constructor() {
    this.smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
    this.init();
  }
  init() {
    for (let i = 0; i < this.smoothScrollTrigger.length; i++) {
      this.smoothScrollTrigger[i].addEventListener("click", (e) => {
        e.preventDefault();
        let href = this.smoothScrollTrigger[i].getAttribute("href");
        let targetElement = document.getElementById(href.replace("#", ""));
        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = 80;
        const target = rect + offset - gap;
        window.scrollTo({
          top: target,
          behavior: "smooth",
        });
      });
    }
  }
}
